<template>
  <component
    :is="isDialog?'a-modal':'div'"
    :visible="true"
    @cancel="onCancel"
    :maskClosable="maskClosable"
    :width="width"
    @ok="onSubmitEvent"
    :footer="isPreView?null:undefined"
    :title="title">
    <a-form-model
      ref="form" :model="form" :rules="editRules" :label-col="{span:labelColSpan}" :wrapper-col="{span:wrapperColSpan}"
      class="withdraw-form">
      <slot name="header" v-bind="form"></slot>
      <template v-for="item in editConfigList">
        <a-form-model-item
          v-if="!item.useFun || (item.useFun(form))"
          :label="item.name"
          :prop="item.key"
          :colon="!item.name"
          :key="item.key">
          <slot v-if="item.slot|| item.type==='slot'" :name="item.key" :form="form" :item="item"></slot>
          <a-select
            v-else-if="item.type==='select' || item.selectOptions"
            v-model:value="form[item.key]"
            :options="item.selectOptions"
            :disabled="item.disabled"
            :mode="item.mode?item.mode:'default'"
          >
          </a-select>
          <a-radio-group
            v-else-if="item.type==='radio' || (item.radioOptions&&item.radioOptions.length)"
            v-model:value="form[item.key]"
            :disabled="item.disabled"
          >
            <a-radio
              v-for="(item,index) in item.radioOptions"
              :key="index"
              :value="item.value">{{ item.label }}
            </a-radio>
          </a-radio-group>
          <a-checkbox-group
            v-else-if="item.type==='checkbox' || (item.checkOptions&&item.checkOptions.length)"
            v-model:value="form[item.key]"
            :disabled="item.disabled"
            class="custom-checkbox-group"
          >
            <a-checkbox
              v-for="item in item.checkOptions"
              :key="item.value"
              :value="item.value"
              class="checkbox-item"
            >
              {{ item.label }}
            </a-checkbox>
          </a-checkbox-group>
          <a-textarea
            v-else-if="item.type==='textarea'"
            :rows="item.rows?item.rows:4"
            style="width: 100%"
            :placeholder="item.placeholder"
            v-model:value="form[item.key]"
            :disabled="item.disabled"
          ></a-textarea>
          <a-input
            v-else
            style="width: 100%"
            :placeholder="item.placeholder"
            v-model:value="form[item.key]"
            :disabled="item.disabled"
            :suffix="item.suffix?item.suffix:''"
          ></a-input>
        </a-form-model-item>
      </template>
    </a-form-model>
  </component>
</template>
<script>
export default {
  name: 'SimpleFormEditorDialog',
  props: {
    isDialog: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '',
      required: true
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    isPreView: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 800
    },
    labelColSpan: {
      type: Number,
      default: 6
    },
    wrapperColSpan: {
      type: Number,
      default: 18
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    editConfigList: {
      type: Array,
      default: () => {
        return []
      }
    },
    rules: {
      type: Object,
      default: () => {
        return {}
      }
    },
    editKeys: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      form: {},
      editRules: {},
      labelCol: { span: 6 },
      wrapperCol: { span: 18 }
    }
  },
  mounted() {
    this.form = {
      ...this.item
    }
    this.editRules = { ...this.rules }
  },
  methods: {
    onSubmitEvent() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('ok', { ...this.form })
        } else {
          this.$message.error('请完善表单信息！')
        }
      })
    },
    onCancel() {
      this.$emit('cancel')
    },
    /**
     * 更新标准数据
     * @param key
     * @param value
     */
    updateFormData(key, value) {
      if (key) {
        this.form[key] = value
      }
    },
    getFormDataByKey(key) {
      if (key) {
        return this.form[key]
      }
    },
    validateFormData(key) {
      this.$refs.form?.validate(typeof key === 'string' ? [key] : key)
    }
  }
}
</script>


<style scoped lang="less">

</style>